<template>
  <div class="print-container">
    <b-modal
      ref="customModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      :hide-header="true"
      :hide-footer="true"
      :visible="showCustomModal"
    >
      <div class="w-100 text-right">
        <a class="modal-close text-right" @click="onHideCustomModal">x</a>
      </div>
      <p v-html="skipped_text"></p>
    </b-modal>

    <b-progress :max="100" v-if="progress.value" class="mb-2" animated striped>
      <b-progress-bar :value="progress.value" variant="success">
        <span style="color:#212529;">{{ progress.label }}...</span>
      </b-progress-bar>
    </b-progress>

    <div class="card mb-3" v-if="summary_text">
      <div class="card-body">
        <span v-html="summary_text"></span>
        <button type="button" class="close red-circle-close" @click="closeSummary">×</button>
      </div>
    </div>

    <div class="clearfix"></div>

    <div class="card">
      <LoadingSpinner v-if="isLoading" />

      <div class="card-header blue">Batch Label History (Links will expire within 72 hours from processed)</div>
      <div class="card-body">
        <div class="table-wrapper">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Batch Name</th>
                <th>Origin</th>
                <th>Number of Labels</th>
                <th>Unable to Process</th>
                <th>Paper Size</th>
                <th>Printed By</th>
                <th>Date Created</th>
                <th>Expires in</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in data" :key="i">
                <td class="text-left">
                  <a target="_blank" :href="v.url">
                    <i class="fa fa-download mr-1" aria-hidden="true"></i> {{ getBatchName(v.batch_name) }}
                  </a>
                </td>
                <td>{{ v.printed_on }}</td>
                <td>{{ v.label_count }}</td>
                <td :class="['custom-modal', {'is-disabled': getSkippedCount(v.skipped) == 0}]" @click="onShowCustomModal(v.skipped)"><i :class="['fa', 'fa-exclamation-triangle', 'fa-lg', getSkippedCount(v.skipped) == 0 ? 'text-black-50' : 'text-danger']" aria-hidden="true"></i> {{ getSkippedCount(v.skipped) }}</td>
                <td>{{ setType(v.type) }}</td>
                <td>{{ v.printed_by || "Admin"}}</td>
                <td>{{ v.created_at|readableDate }}</td>
                <td>{{ v.expires_in || getExpirationTime(v.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-button size="sm" @click="redirectBack">
          <span class="glyphicon glyphicon-arrow-left"></span> Back
        </b-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.print-container {
  position: relative;
  .card {
    margin-bottom: 1.5rem;
    .card-header {
      color: #fff;
      font-size: 0.95rem !important;
      padding: 0.10rem 1rem;
    }
  }
  .table-wrapper {
    // max-height: 550px;
    max-height: 75vh;
    overflow-y: auto;
    margin-bottom: 1rem;
  }
  .table {
    text-align: center;
    th, td {
      font-size: .95rem;
      padding: 0.5rem;
    }
  }
}
.custom-modal {
  cursor: pointer;
  transition: all 0.3s;
  &:hover, &:focus, &:active {
    background: #e4e4e4;
  }
  &.is-disabled {
    cursor: auto;
    pointer-events: none;
  }
}
.modal-close {
  cursor: pointer;
  padding:  0.5rem .3rem;
}
</style>

<script>
import LoadingSpinner from "../../../components/LoadingSpinner";

import { mapGetters, mapActions } from "vuex";

import moment from 'moment-timezone';

export default {
  components: {
    chan: null,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      data: [],
      summary_text: null,
      showCustomModal: false,
      skipped_text: ''
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      batchPrintSubscription: "ws/getBatchPrintSubscription",
      progress: "ws/getBatchPrintProgress",
    }),
  },
  async mounted() {
    this.getPrintHistory();

    const chan = this.batchPrintSubscription;
    chan.on("batch_data", ({summary}) => {
      console.log("batch_data called history");
      this.summary_text = summary;
    })
    chan.on("batch_print_done", () => {
      this.getPrintHistory();
    });
  },
  methods: {
    ...mapActions(["addPrintJob"]),
    async getPrintHistory() {
      this.isLoading = true;
      const response = await axios.get('/user/print-histories')
      this.data = response.data;
      // console.log('history', this.data);
      this.isLoading = false;
    },
    getExpirationTime(date) {
      const expiration_date = moment(date).add(72, 'h');
      const diff = expiration_date.diff(moment(), 'hours');
      if (diff > 0) return `${diff} hour(s)`;
      return 'Expired'
    },
    setType(t) {
      const size = t? t.substring(4,t.length) : "4X6";
      return size === "8X11"? "8.5X11" : size;
    },
    getBatchName(name) {
      let bName = name.split('.');
      if (bName.length < 2) return name;
      return bName.slice(0, -1).join('.')
    },
    getSkippedCount(skipped) {
      const data = JSON.parse(skipped);
      if (!data) return 0;
      return data.length;
    },
    onShowCustomModal(skipped){
      const data = JSON.parse(skipped);
      if(data != null && data.length > 0){
        this.skipped_text = data.reduce((all, current) => {
          const nameErr = current.name.split("-");
          return `${all}
            <strong>${nameErr[0] || 'N/A'}</strong><br />
            &nbsp;&nbsp;
            - <em>${nameErr[1] || 'N/A'}</em>
            <hr />
            `
        }, '');
      }else{
        this.skipped_text = "No unprocessed label";
      }
      this.showCustomModal = true;
    },
    async onHideCustomModal(){
      this.skipped_text = '';
      this.showCustomModal = false;
    },
    closeSummary(){
      this.summary_text = null;
    },
    redirectBack(){
      this.$router.back();
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Import/History.vue